<template>
  <div class="bg-bhav-cool-gray-50 p-1 rounded-lg flex items-center group">
    <label
        v-for="(view, index) in views"
        :key="view.value"
        :for="`view-toggle-${view.value}`"
        @click="selectView(view.value)"
        @mouseenter="hoveredIndex = index"
        @mouseleave="hoveredIndex = null"
        class="p-2 w-10 h-9 rounded-lg text-2xl leading-none flex items-center justify-center cursor-pointer transition-colors"
        :class="getViewClass(view.value, index)">
      <span :class="view.icon"></span>
      <span class="sr-only">{{ view.label }}</span>
    </label>
    <input
        v-for="view in views"
        :key="`input-${view.value}`"
        type="checkbox"
        :id="`view-toggle-${view.value}`"
        class="sr-only" />
  </div>
</template>

<script>
export default {
  props: {
    modelValue: {
      type: String,
      required: true
    },
    views: {
      type: Array,
      required: true,
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      hoveredIndex: null
    }
  },
  methods: {
    selectView(value) {
      this.$emit('update:modelValue', value);
    },
    getViewClass(value, index) {
      const isActive = this.modelValue === value;
      const isHoveringOther = this.hoveredIndex !== null && this.hoveredIndex !== index;

      if (isHoveringOther && isActive) {
        return 'bg-transparent text-bhav-blue-100';
      } else if (isActive) {
        return 'bg-white text-bhav-blue-500';
      } else {
        return 'bg-transparent text-bhav-blue-100 hover:bg-white hover:text-bhav-blue-300';
      }
    }
  }
}
</script>
